import { render } from "./noticias.vue?vue&type=template&id=b0d22384&scoped=true"
import script from "./noticias.vue?vue&type=script&lang=js"
export * from "./noticias.vue?vue&type=script&lang=js"

import "./noticias.vue?vue&type=style&index=0&id=b0d22384&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d22384"]])

export default __exports__